<template>
  <div class="ilan-result-container">
    <img class="bg-image" src="/static/images/ilan/bg.png" />
    <img class="bg-logo" src="/static/images/ilan/bg-logo.png" />
    <img class="logo" src="/static/images/ilan/logo.png" />
    <img class="ch-system" src="/static/images/ilan/ch-system.png" />
    <img class="en-system" src="/static/images/ilan/en-system.png" />

    <div class="white-card">
      <div v-if="replyCode == '500'" class="card-content">
        <img class="warn-icon" src="/static/images/ilan/warn2.png" />
        <div class="code-line">您所查询的数码为:</div>
        <div class="code-line">{{ antiCode }}</div>
        <div class="caution-line">数码信息错误</div>
        <div class="info-btn" @click="handleScan">重新查询</div>
      </div>

      <div v-if="replyCode == '300101' || replyCode == '300102'" class="card-content">
        <div class="code-line">{{ antiCode }}</div>
        <div class="result-line" v-html="message"></div>
        <div class="scan-grid">
          <div class="grid-item grid-icon">
            <img class="result-scan" src="/static/images/ilan/result-scan.png" />
          </div>
          <div class="grid-item grid-count">
            <span class="scan-count">扫码次数&nbsp;{{ queryCount }}</span>
          </div>
          <div class="grid-item grid-time">
            <div class="time-section">
              <div class="time-line">首次扫码：{{ firstQueryTime }}</div>
              <div class="time-line">最近扫码：{{ preQueryTime }}</div>
            </div>
          </div>
        </div>
      </div>


      <div v-if="replyCode == '300105'" class="card-content">
        <div class="code-line">{{ antiCode }}</div>
        <div v-html="message"></div>
        <div class="report-btn" @click="goToReport">点击举报</div> 
      </div>


      <div v-if="replyCode == '300106'" class="card-content">
        <img class="warn-icon" src="/static/images/ilan/warn.png" />
        <div v-html="message"></div>
        <div class="info-btn2" @click="handleScan">重新查询</div>
      </div>
    </div>


  </div>
</template>

<script>
import { getAntiData, getJSSDK } from '../../api/api'
import wx from 'weixin-js-sdk'

export default {
  name: 'ILanResult',
  data() {
    return {
      appId: process.env.ENV_NUM === '1' ? 'wxbc22565b3e7a59fd' : 'wxbc22565b3e7a59fd',
      eno: process.env.ENV_NUM === '1' ? '138344550634' : '138880439295',
      antiCode: '',
      replyCode: '0',
      firstQueryTime: '',
      preQueryTime: '',
      message: '',
      queryCount: 0,
    }
  },
  mounted() {
    this.getWxJs()
    this.queryAntiCode(this.$route.query.c)
  },
  methods: {
    async queryAntiCode(code) {
      try {

        if (code && code.length >= 16) {
          this.antiCode = code.substring(0, 16)
        } else if (code) {
          this.antiCode = code
        }
        const res = await getAntiData(this.antiCode, this.eno)

        const data = res.data
        if (data == null || data.code == "500") {
          this.replyCode = data.code
          return
        }
        this.message = data.message
        var replyCode = data.data.replyCode
        if (replyCode === "300101" || replyCode === "300102") {
          this.firstQueryTime = data.data.firstQueryTime || ''
          this.preQueryTime = data.data.preQueryTime || data.data.firstQueryTime || ''
          this.queryCount = data.data.queryCount || ''
        }
        this.replyCode = replyCode
      } catch (error) {
        console.error('防伪查询失败:', error)
        this.showNotExist = true
      }
    },
    goToReport() {
      this.$router.push({
        path: '/ilan/report',
        query: { c: this.antiCode }
      })
    },
    getWxJs() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, this.appId).then(res => {
        const data = res.data.data
        wx.config({
          debug: false,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          openTagList: ["wx-open-launch-weapp", "wx-open-launch-app"],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            'openEnterpriseChat',
            'openCustomerService'
          ]
        })
      })
    },
    handleScan() {
      wx.scanQRCode({
        needResult: 1,
        scanType: ["qrCode", "barCode"],
        success: res => {
          var scanResult = res.resultStr
          var scanQRCode = scanResult
          if (scanResult.startsWith('http')) {
            let parts = scanResult.split('?');
            scanQRCode = parts.length > 1 ? parts[1] : '';
          }
          this.queryAntiCode(scanQRCode)
        }
      });
    }
  }
}
</script>

<style scoped>
.ilan-result-container {
  width: 100vw;
  height: 100vh;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.bg-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
}

.bg-logo {
  position: absolute;
  top: 8vh;
  left: 50%;
  width: 80vw;
  transform: translateX(-50%);
  z-index: 2;
}

.logo {
  position: absolute;
  top: 11vh;
  left: 50%;
  width: 33vw;
  transform: translateX(-50%);
  z-index: 3;
}

.ch-system {
  position: absolute;
  top: 20vh;
  left: 50%;
  width: 60vw;
  transform: translateX(-50%);
  z-index: 2;
}

.en-system {
  position: absolute;
  top: 24.5vh;
  left: 50%;
  width: 60vw;
  transform: translateX(-50%);
  z-index: 2;
}

.white-card {
  position: absolute;
  top: 31vh;
  left: 50%;
  transform: translateX(-50%);
  width: 90vw;
  height: 55vh;
  background-color: rgba(255, 255, 255, 0.9);
  border: 1.5vw solid rgba(255, 255, 255, 1);
  border-radius: 25px;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 5vh;
}

.card-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding: 0 0vw;
}

.code-line {
  color: black;
  font-size: 4.5vw;
  margin-bottom: 2.5vh;
  letter-spacing: 0.5vw;
}

.warn-icon {
  width: 12vw;
  height: 12vw;
  margin-bottom: 1.5vh;
}

.not-exist-line {
  color: black;
  font-size: 4.5vw;
  font-weight: bold;
  margin-bottom: 2vh;
  text-align: center;
}

.caution-line {
  color: rgb(179, 0, 0);
  font-size: 4vw;
  font-weight: bold;
  margin-bottom: 3vh;
  text-align: center;
}

.retry-line {
  color: rgb(90, 90, 90);
  font-size: 3vw;
  margin-bottom: 2vh;
  text-align: center;
}

.code-box {
  width: 75%;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 1.5vh 2vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5vh;
}

.code-label {
  color: rgb(90, 90, 90);
  font-size: 3vw;
  text-align: center;
}

.code-value {
  color: rgb(70, 70, 70);
  font-size: 4vw;
  font-weight: bold;
  letter-spacing: 0.5vw;
  text-align: center;
}

.result-line {
  color: black;
  font-size: 4.5vw;
  display: flex;
  align-items: flex-end;
}

.error-line {
  color: rgb(179, 0, 0);
  font-size: 4.5vw;
  margin-bottom: 2.5vh;
  max-width: 63vw;
  word-wrap: break-word;
  word-break: break-all;
  text-align: center;
}

.warning-line {
  color: rgb(90, 90, 90);
  font-size: 3.5vw;
  margin-bottom: 2.5vh;
  max-width: 70vw;
  word-wrap: break-word;
  word-break: break-all;
  text-align: center;
}

.report-btn {
  background-color: rgb(179, 0, 0);
  color: white;
  font-size: 4.5vw;
  font-weight: bold;
  padding: 1.5vh 5vw;
  border-radius: 25px;
  margin-top: 8vh;
  margin-bottom: 0vh;
  cursor: pointer;
  width: 65vw;
  text-align: center;
}

.info-btn {
  background-color: rgb(1, 63, 179);
  color: white;
  font-size: 4.5vw;
  font-weight: bold;
  padding: 1.5vh 5vw;
  border-radius: 25px;
  margin-top: 8vh;
  margin-bottom: 0vh;
  cursor: pointer;
  width: 70vw;
  text-align: center;
}

.info-btn2 {
  background-color: rgb(1, 63, 179);
  color: white;
  font-size: 4.5vw;
  font-weight: bold;
  padding: 1.5vh 5vw;
  border-radius: 25px;
  margin-top: 4vh;
  margin-bottom: 0vh;
  cursor: pointer;
  width: 70vw;
  text-align: center;
}

.highlight {
  color: rgb(1, 63, 179);
  font-size: 6vw;
  margin-bottom: -2px;
  font-weight: bold;
}

.scan-grid {
  display: grid;
  grid-template-columns: 25% 75%;
  grid-template-rows: auto auto;
  gap: 1vh;
  margin-top: 10vh;
  margin-bottom: 2vh;
  width: 100%;
  box-sizing: border-box;
}

.grid-item {
  display: flex;
  align-items: center;
}

.grid-icon {
  justify-content: flex-end;
  padding-right: 2vw;
}

.grid-count {
  justify-content: flex-start;
  padding-left: 2vw;
}

.grid-time {
  grid-column: 2;
  grid-row: 2;
  align-items: flex-start;
  padding-left: 2vw;
}

.result-scan {
  width: 8vw;
  height: 8vw;
}

.scan-count {
  color: black;
  font-size: 4.5vw;
  font-weight: bold;
}

.time-section {
  display: flex;
  flex-direction: column;
  gap: 1vh;
}

.time-line {
  color: black;
  font-size: 3.5vw;
}
</style>



// WEBPACK FOOTER //
// src/components/ILan/Result.vue